var _rect, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS8Kreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "s8kreis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_40",
    "data-name": "Rechteck 40",
    width: 150,
    height: 150,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_150",
    "data-name": "Gruppe 150",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 38.8,
    cy: 38.8,
    r: 38.8,
    transform: "translate(36.2 37.1)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_494",
    "data-name": "Pfad 494",
    d: "M75,42.6A33.2,33.2,0,1,1,41.8,75.8h0A33.375,33.375,0,0,1,75,42.6m0-5.5a38.8,38.8,0,1,0,38.8,38.8h0A38.773,38.773,0,0,0,75.055,37.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_495",
    "data-name": "Pfad 495",
    d: "M46.2,81.8H53c.6,4.1,2.6,5.6,7.6,5.6,3.5,0,6.5-1.2,6.5-4.4s-3.2-3.8-8.2-5C53,76.5,47.4,75.1,47.4,68c0-6.8,5.3-10,12.9-10s12.4,3.8,12.9,10.6H66.7c-.3-3.5-2.9-5-6.5-5S54,65.1,54,67.4c0,2.6,2.4,3.5,7.4,4.7,6.5,1.5,12.1,2.9,12.1,10.3,0,6.8-5.6,10.6-13.2,10.6C51.5,92.9,46.2,88.8,46.2,81.8Z",
    fill: "#ffcb00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_496",
    "data-name": "Pfad 496",
    d: "M77.9,82.9a8.909,8.909,0,0,1,5.9-8.5h0a6.409,6.409,0,0,1-4.4-6.5c0-5.6,4.7-8.5,11.8-8.5s11.5,2.9,11.5,8.5c0,2.9-1.8,5-4.4,6.5h0a8.62,8.62,0,0,1,5.9,8.2c0,6.8-5.6,10.3-12.9,10.3C83.8,92.9,77.9,89.4,77.9,82.9Zm19.5-.3c0-3.2-2.4-5.6-6.2-5.6s-6.5,2.1-6.5,5.6c0,3.2,2.4,5,6.5,5C94.7,87.6,97.4,85.6,97.4,82.6Zm-.9-14.1c0-2.6-2.1-4.1-5.3-4.1-3.5,0-5.3,1.8-5.3,4.1,0,2.4,2.1,4.4,5.3,4.4C94.4,72.6,96.5,70.9,96.5,68.5Z",
    fill: "#ffcb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS8Kreis);
export default __webpack_public_path__ + "static/media/s8kreis.524511f8a9dd8405675279f591171394.svg";
export { ForwardRef as ReactComponent };